export default {
    messagesPathName : "/messages",
    messagesLinkTo: "messages"
  }